import { createFileRoute, Link } from "@tanstack/react-router";
import { CTAButton } from "#/components/shared/CTAButton";

export const Route = createFileRoute("/$")({
  component: NotFound,
});

function NotFound() {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center bg-graphite px-6 text-center text-white">
      <p className="font-heading text-7xl font-extrabold text-flame">404</p>
      <h1 className="mt-4 font-heading text-2xl font-bold">This page hasn't been poured yet.</h1>
      <p className="mt-3 max-w-md text-concrete">
        The page you're looking for doesn't exist or has moved. Let's get you back on solid ground.
      </p>
      <div className="mt-8">
        <Link to="/" className="no-underline">
          <CTAButton variant="flame-bubble" size="lg">
            Back to Home
          </CTAButton>
        </Link>
      </div>
    </main>
  );
}
